import { Practitioner, PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { StrongText, StyledFlex } from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../../translations';
import { PractitionerUpdatePermissionsModalOpener } from '../../permissions/PractitionerUpdatePermissionsModal.opener';
import { PractitionerNameLink } from '../shared/PractitionerNameLink';

enum PractitionerIdentificationType {
   MEDICAL_LICENCE_NUMBER = 'MEDICAL_LICENCE_NUMBER',
   PESEL = 'PESEL',
}

export const getPractitionerIdentificationType = (
   practitioner: Practitioner
): PractitionerIdentificationType | undefined => {
   if (practitioner.medicalLicenceNumber) {
      return PractitionerIdentificationType.MEDICAL_LICENCE_NUMBER;
   }
   if (practitioner.pesel) {
      return PractitionerIdentificationType.PESEL;
   }

   return undefined;
};

export const getPractitionerIdentificationNumber = (practitioner: Practitioner): string | undefined => {
   switch (getPractitionerIdentificationType(practitioner)) {
      case PractitionerIdentificationType.MEDICAL_LICENCE_NUMBER:
         return practitioner.medicalLicenceNumber!.getValue();
      case PractitionerIdentificationType.PESEL:
         return practitioner.pesel!.asString();
      default:
         return undefined;
   }
};

export type PractitionerCellProps = {
   readonly practitioner: PractitionerView;
   readonly onUpdate: VoidFunction;
   readonly editable: boolean;
};

export const PractitionerCell = (props: PractitionerCellProps): JSX.Element => {
   const translate = useTranslate();
   const identificationType = getPractitionerIdentificationType(props.practitioner);
   const identification = identificationType
      ? `${translate(
           practitionersTranslationKeys.identificationType[identificationType]
        )}: ${getPractitionerIdentificationNumber(props.practitioner)}`
      : undefined;

   return (
      <StyledFlex direction='column' gap='5px'>
         {props.editable ? (
            <PractitionerUpdatePermissionsModalOpener practitioner={props.practitioner} onUpdate={props.onUpdate}>
               {({ openModal }) => <PractitionerNameLink onClick={openModal} practitioner={props.practitioner} />}
            </PractitionerUpdatePermissionsModalOpener>
         ) : (
            <StrongText testId={'lastName'}>
               {`${props.practitioner.lastName.asString()} ${props.practitioner.firstName.asString()}`}
            </StrongText>
         )}
         {identification ? <span>{identification}</span> : null}
      </StyledFlex>
   );
};
